import { Service } from "../index";
export function loginByWallet(data) {
  return Service({
    url: "/api/v2/art/user/loginByWallet",
    data,
    method: "post",
  });
}
// //获取IP属地
// export function getIPDetails(params) {
//   return Service({
//     url: "http://ip-api.com/json",
//     params: params,
//     method: "get",
//   });
// }
// 获取IP属地
export function getIPDetails() {
  return Service({
    url: "https://ipinfo.io/json",
    method: "get",
  });
}

export function userLogin(params) {
  return Service({
    url: "/api/v1/art/user/login",
    data:params,
    method: "post",
  });
}
//获取验证码
export function sendEmail(params) {
  return Service({
    url: `/api/v1/art/sms/sendEmail?email=${params.email}`,
    data:params,
    method: "post",
  });
}
//邮箱登录
export function loginByEmail(params) {
  return Service({
    url: "/api/v2/art/user/loginByEmail",
    data:params,
    method: "post",
  });
}
//盲和列表
export function magicBox(params) {
  return Service({
    url: "/api/v1/art/magic-box/page",
    data:params,
    method: "post",
  });
}

//盲盒商品列表
export function magicBoxGoods(params) {
  return Service({
    url: `/api/v1/art/magic-box/detail/goods?magicBoxId=${params.magicBoxId}    `,
    data:params,
    method: "post",
  });
}
export function buyMagicBox(params) {
  return Service({
    url: "/api/v1/art/magic-box/buy",
    data:params,
    method: "post",
  });
}
//用户开启的矿场信息
export function crystalMineList(params) {
 return Service({
    url: "/api/v1/art/crystal/mineList",
    params,
    method: "get",
  });
}
//账户户信息详情
export function accountDetail(params) {
  return Service({
    url: "/api/v1/art/account/detail",
    params,
    method: "get",
  });
}
//挖矿邀请的好友
export function userPetInfo(params) {
  return Service({
    url: "/api/v1/art/crystal/userPetInfo",
    params,
    method: "get",
  });
}
//查询用户的信息
export function getUserInfo(params) {
  return Service({
    url: "/api/v1/art/user/info",
    params,
    method: "get",
  });
}
//集卡卡片信息
export function petStock(params) {
  return Service({
    url: "/api/v1/art/pet/stock",
    data:params,
    method: "post",
  });
}
// nfts商品接口
export function GetProductList(params) {
  return Service({
    url: "/api/v1/art/goods",
    params,
    method: "get",
  });
}
//商品详情
export function getProductDetal(params) {
  return Service({
    url: "/api/v1/art/goods/detail",
    params,
    method: "get",
  });
}
//寄售藏品最低、高价
export function querySellStat(params) {
  return Service({
    url: "/api/v1/art/sell/querySellStat",
    data:params,
    method: "post",
  });
}
//关注
export function userFocus(params) {
  return Service({
    url: "/api/v1/art/userCollection/focus",
    data:params,
    method: "post",
  });
}
//融合
export function exchangeQuery(params) {
  return Service({
    url: "/api/v1/art/exchange/integratedQueryPage",
    data:params,
    method: "post",
  });
}
//合成
export function GetCompositeList(params) {
  return Service({
    url: "/api/v1/art/goods/composite",
    params,
    method: "get",
  });
}
//合成详情
export function getCompositeDetal(id) {
  return Service({
    url: `/api/v1/art/goods/composite/detail/${id}`,
    method: "get",
  });
}
//抽奖
export function lotteryPage(params) {
  return Service({
    url: "/api/v1/art/lottery/page",
    data:params,
    method: "post",
  });
}
//抽奖详情
export function turntableDetail(params) {
  return Service({
    url: `/api/v1/art/lottery/turntable/detail/${params}`,
    method: "get",
  });
}
//兑换
export function exchangePageList(params) {
  return Service({
    url: "/api/v1/art/goods/exchange/pageList",
    data:params,
    method: "post",
  });
}
//兑换详情
export function exchangeDetail(params) {
  return Service({
    url: `/api/v1/art/goods/exchange/detail/${params}`,
    method: "get",
  });
}
//寄售
export function mySellList(params) {
  return Service({
    url: "/api/v1/art/sell/mySellList",
    data:params,
    method: "post",
  });
}
//修改名字
export function modifyNickName(params) {
  return Service({
    url: "/api/v1/art/user/modifyNickName",
    data:params,
    method: "post",
  });
}
// 获取上传token
export function getUploadToken() {
  return Service({
    url: "/api/v1/art/app/uploadToken",
    method: "get",
  });
}
//修改头像
export function modifyAvatar(params) {
  return Service({
    url: "/api/v1/art/user/modifyAvatar",
    data:params,
    method: "post",
  });
}
//查询版本/更新/公告
export function noticeList(params) {
  return Service({
    url: "/api/v1/art/announcements",
    params,
    method: "get",
  });
}
export function getAnnouncementsDetails(params) {
  return Service({
    url: `/api/v1/art/announcements/${params}`,
    method: "get",
  });
}
//口令红包
export function robRedEnvelope(params) {
  return Service({
    url: "/api/v1/art/account/robRedEnvelope",
    params,
    method: "get",
  });
}
//订单记录
export function orderRecord(params) {
  return Service({
    url: "/api/v1/art/userCollection/ownRecord",
    data:params,
    method: "post",
  });
}
//我的储物柜 待处理
export function myBoxGoods(params) {
  return Service({
    url: "/api/v1/art/magic-box-order/myBoxGoods",
    data:params,
    method: "post",
  });
}
//已分解
export function myBoxOrderPage(params) {
  return Service({
    url: "/api/v1/art/magic-box-order/orderPage",
    data:params,
    method: "post",
  });
}
//全部的nft
export function collectionRecord(params) {
  return Service({
    url: "/api/v1/art/userCollection/own",
    data:params,
    method: "post",
  });
}
//nft详情
export function collectionRecordList(params) {
  return Service({
    url: "/api/v1/art/userCollection/ownDetail",
    data:params,
    method: "post",
  });
}
//寄售的nft
export function sellList(params) {
  return Service({
    url: "/api/v1/art/sell/sellList",
    data:params,
    method: "post",
  });
}
//我的商品列表
export function tidePage(params) {
  return Service({
    url: "/api/v1/art/goods/tide/page",
    data:params,
    method: "post",
  });
}
//我的商品列表
export function collectionStat(params) {
  return Service({
    url: "/api/v1/art/userCollection/collectionStat",
    data:params,
    method: "post",
  });
}
//添加收货地址
export function saveOrUpdateCourierAddress(params) {
  return Service({
    url: "/api/v1/art/courier/address/saveOrUpdateCourierAddress",
    data:params,
    method: "post",
  });
}
//查询收货地址
export function getCourierAddressList(params) {
  return Service({
    url: "/api/v1/art/courier/address/getCourierAddressList",
    data:params,
    method: "post",
  });
}

//修改密码
export function setPassword(params) {
  return Service({
    url: "/api/v1/art/account/setPayPassword",
    data:params,
    method: "post",
  });
}

export function bindEmail(params) {
  return Service({
    url: "/api/v1/art/user/bindEmail",
    data:params,
    method: "post",
  });
}
//签到
export function userClockInDo(params) {
  return Service({
    url: "/api/v1/art/userClockIn/do",
    params,
    method: "get",
  });
}
//签到列表
export function userClockInCalendar(params) {
  return Service({
    url: "/api/v1/art/userClockIn/calendar",
    params,
    method: "get",
  });
}

//vip助力查询
export function magicBoxUserLevelAssistancePage(params) {
  return Service({
    url: "/api/v1/art/magic-box-user-level/assistancePage",
    data:params,
    method: "post",
  });
}
//领取
export function magicBoxUserLevelDraw(params) {
  return Service({
    url: "/api/v1/art/magic-box-user-level/draw",
    params,
    method: "get",
  });
}
//查询用户等级
export function magicBoxUserLevelGetUserLevel(params) {
  return Service({
    url: "/api/v1/art/magic-box-user-level/getUserLevel",
    params,
    method: "get",
  });
}

//成长值查询
export function magicBoxUserLevelGrowthPointDetailPage(params) {
  return Service({
    url: "/api/v1/art/magic-box-user-level/growthPointDetailPage",
    data:params,
    method: "post",
  });
}
//支付密码验证
export function validatePassword(params) {
  return Service({
    url: "/api/v1/art/account/validate",
    params,
    method: "get",
  });
}
//购买
export function exchangeBuy(params) {
  return Service({
    url: "/api/v1/art/exchange/buy",
    data:params,
    method: "post",
  });
}
//退出登录
export function userLogout() {
  return Service({
    url: "/api/v1/art/exchange/buy",
    params,
    method: "get",
  });
}
